import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from './cn';
import { R, T, S, FONT } from './tokens';

interface SectionProps {
  title: string;
  icon: React.ElementType;
  defaultCollapsed?: boolean;
  children: React.ReactNode;
  action?: React.ReactNode;
  badge?: number | string;
  className?: string;
}

export function Section({
  title,
  icon: Icon,
  defaultCollapsed = false,
  children,
  action,
  badge,
  className,
}: SectionProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div
      className={cn(
        'bg-white border border-slate-100 overflow-hidden',
        R.base,
        S.sm,
        className,
      )}
    >
      <button
        type="button"
        aria-expanded={!collapsed}
        onClick={() => setCollapsed((c) => !c)}
        className={cn(
          'w-full flex items-center gap-2 px-4 py-3 bg-white hover:bg-slate-50 text-left cursor-pointer',
          T.fast,
          !collapsed && 'border-b border-slate-100',
        )}
      >
        <Icon size={15} className="text-slate-500 shrink-0" />
        <span className={cn(FONT.title, 'text-slate-700 flex-1')}>{title}</span>
        {badge !== undefined && (
          <span className="text-xs font-bold px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-700">
            {badge}
          </span>
        )}
        {action && (
          <div onClick={(e) => e.stopPropagation()}>{action}</div>
        )}
        <ChevronDown
          size={14}
          className={cn(
            'text-slate-400',
            T.fast,
            collapsed && '-rotate-90',
          )}
        />
      </button>
      {!collapsed && (
        <div className="p-4 space-y-4">{children}</div>
      )}
    </div>
  );
}
